var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkbenchIcon = function SvgWorkbenchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "23px",
    viewBox: "0 0 36 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1---internal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-14",
    transform: "translate(-162.000000, -904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-5",
    transform: "translate(162.000000, 904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(0.000000, 4.052632)",
    stroke: "#E74C3C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.38947368,1 C1.17437331,1 1,1.17437331 1,1.38947368 L1,16.9634675 C1,17.1785679 1.17437331,17.3529412 1.38947368,17.3529412 L33.9789474,17.3529412 C34.1940477,17.3529412 34.3684211,17.1785679 34.3684211,16.9634675 L34.3684211,1.38947368 C34.3684211,1.17437331 34.1940477,1 33.9789474,1 L1.38947368,1 Z",
    id: "Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Asset-15-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0003523,3.96466007 L24.9990637,3.47855535 L25.0000007,1.1113868 C25.0000393,1.14384468 24.7922586,0.999778267 24.3995296,1.00000203 L11.6004415,1.00916935 C11.2080957,1.0093941 11.0013201,1.15311858 11.0013201,1.12062043 L11.0003523,3.96466007 Z",
    id: "Path",
    stroke: "#E74C3C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#E74C3C",
    points: "5.7493717e-16 12 0 10 8 10 8 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#E74C3C",
    points: "28 12 28 10 35 10 35 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#E74C3C",
    points: "11 12 11 10 24 10 24 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28799579,8.67368421 C8.21032944,8.67368421 8.14736842,8.73664523 8.14736842,8.81431158 L8.14736842,12.4488463 C8.14736842,12.5265127 8.21032944,12.5894737 8.28799579,12.5894737 L10.6593726,12.5894737 C10.737039,12.5894737 10.8,12.5265127 10.8,12.4488463 L10.8,8.81431158 C10.8,8.73664523 10.737039,8.67368421 10.6593726,8.67368421 L8.28799579,8.67368421 Z M8.28799579,7.53684211 L10.6593726,7.53684211 C11.3648995,7.53684211 11.9368421,8.10878467 11.9368421,8.81431158 L11.9368421,12.4488463 C11.9368421,13.1543732 11.3648995,13.7263158 10.6593726,13.7263158 L8.28799579,13.7263158 C7.58246888,13.7263158 7.01052632,13.1543732 7.01052632,12.4488463 L7.01052632,8.81431158 C7.01052632,8.10878467 7.58246888,7.53684211 8.28799579,7.53684211 Z",
    id: "Rectangle",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7090484,8.67368421 C24.6313821,8.67368421 24.5684211,8.73664523 24.5684211,8.81431158 L24.5684211,12.4488463 C24.5684211,12.5265127 24.6313821,12.5894737 24.7090484,12.5894737 L27.0804253,12.5894737 C27.1580916,12.5894737 27.2210526,12.5265127 27.2210526,12.4488463 L27.2210526,8.81431158 C27.2210526,8.73664523 27.1580916,8.67368421 27.0804253,8.67368421 L24.7090484,8.67368421 Z M24.7090484,7.53684211 L27.0804253,7.53684211 C27.7859522,7.53684211 28.3578947,8.10878467 28.3578947,8.81431158 L28.3578947,12.4488463 C28.3578947,13.1543732 27.7859522,13.7263158 27.0804253,13.7263158 L24.7090484,13.7263158 C24.0035215,13.7263158 23.4315789,13.1543732 23.4315789,12.4488463 L23.4315789,8.81431158 C23.4315789,8.10878467 24.0035215,7.53684211 24.7090484,7.53684211 Z",
    id: "Rectangle",
    fill: "#E74C3C"
  })))))));
};
export default SvgWorkbenchIcon;